import { Stack, Table, Text } from '@mantine/core';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { formatCountFr } from '../../../lib/utils/gp-surfaces-format';

import { SamplerCoverageMetricText } from './sampler-coverage-metric-text';

export type GpSurfacesSamplingMetricsValues = {
  carbon_points: number;
  granulo_points: number;
  total_sampling_points: number;
  analysis_count: number;
  granulo_analysis_count: number;
  total_analysis_count: number;
};

type GpSurfacesSamplingMetricsTablesProps = {
  metrics: GpSurfacesSamplingMetricsValues;
};

export const GpSurfacesSamplingMetricsTables: FC<
  GpSurfacesSamplingMetricsTablesProps
> = ({ metrics }) => {
  const { t } = useTranslation();

  return (
    <Stack gap="sm">
      <Stack gap={4}>
        <Text c="dimmed" fw={600} size="xs" tt="uppercase">
          {t('surfacesMap.tables.pointsSection')}
        </Text>
        <Table
          horizontalSpacing="sm"
          layout="fixed"
          verticalSpacing={6}
          withTableBorder
        >
          <Table.Thead>
            <Table.Tr>
              <Table.Th ta="right">
                {t('surfacesMap.tables.carbonShort')}
              </Table.Th>
              <Table.Th ta="right">
                {t('surfacesMap.tables.granuloShort')}
              </Table.Th>
              <Table.Th ta="right">
                {t('surfacesMap.tables.totalShort')}
              </Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            <Table.Tr>
              <Table.Td ta="right">
                <SamplerCoverageMetricText
                  fw={600}
                  value={formatCountFr(metrics.carbon_points)}
                />
              </Table.Td>
              <Table.Td ta="right">
                <SamplerCoverageMetricText
                  fw={600}
                  value={formatCountFr(metrics.granulo_points)}
                />
              </Table.Td>
              <Table.Td ta="right">
                <SamplerCoverageMetricText
                  fw={700}
                  value={formatCountFr(metrics.total_sampling_points)}
                />
              </Table.Td>
            </Table.Tr>
          </Table.Tbody>
        </Table>
      </Stack>
      <Stack gap={4}>
        <Text c="dimmed" fw={600} size="xs" tt="uppercase">
          {t('surfacesMap.tables.analysesSection')}
        </Text>
        <Table
          horizontalSpacing="sm"
          layout="fixed"
          verticalSpacing={6}
          withTableBorder
        >
          <Table.Thead>
            <Table.Tr>
              <Table.Th ta="right">
                {t('surfacesMap.tables.carbonShort')}
              </Table.Th>
              <Table.Th ta="right">
                {t('surfacesMap.tables.granuloShort')}
              </Table.Th>
              <Table.Th ta="right">
                {t('surfacesMap.tables.totalShort')}
              </Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            <Table.Tr>
              <Table.Td ta="right">
                <SamplerCoverageMetricText
                  fw={600}
                  value={formatCountFr(metrics.analysis_count)}
                />
              </Table.Td>
              <Table.Td ta="right">
                <SamplerCoverageMetricText
                  fw={600}
                  value={formatCountFr(metrics.granulo_analysis_count)}
                />
              </Table.Td>
              <Table.Td ta="right">
                <SamplerCoverageMetricText
                  fw={700}
                  value={formatCountFr(metrics.total_analysis_count)}
                />
              </Table.Td>
            </Table.Tr>
          </Table.Tbody>
        </Table>
      </Stack>
    </Stack>
  );
};
